import React from "react";
import * as Ons from "react-onsenui";
import { ActivityStateMixin, ActivityStateMixinState } from "./activities/ActivityStateMixin";
import { API } from "./API";
import { MedflytCovidScreen } from "./CovidModalScreen";
import { isLoading, Loading } from "./Loading";
import {
  AgencyMemberId,
  CoronaReportAllQuestionsResponse,
  CoronaReportSubmitParams,
  OrientationLanguages,
  VisitInstanceId,
} from "./messages";
import { AppState } from "./system/AppState";
import { AgencyWithChatOnlyDetails, AppAgenciesState } from "./system/AppState/AppAgenciesState";
import { getLanguage, langMap } from "./translate";

interface MedflytCovidActivityProps {
  onBackClick: () => void;
  onSubmit: (
    answers: CoronaReportSubmitParams,
    visitInstanceId: VisitInstanceId | null
  ) => Promise<void>;
  agencies: AppAgenciesState | Loading;
  appState: AppState;
  coronaReports: CoronaReportAllQuestionsResponse;
  api: API;
  onAgencyMemberChatClick: (agencyMemberId: AgencyMemberId) => void;
}

interface MedflytCovidActivityState {
  language: OrientationLanguages;
  mixin: ActivityStateMixinState;
}

const defaultLang: OrientationLanguages = "English";

export class MedflytCovidActivity extends React.Component<
  MedflytCovidActivityProps,
  MedflytCovidActivityState
> {
  visitInstanceInterval = null;

  private activityStateMixin: ActivityStateMixin;

  constructor(props: MedflytCovidActivityProps) {
    super(props);

    this.activityStateMixin = new ActivityStateMixin(
      (state) =>
        this.setState((_prevState: MedflytCovidActivityState) => ({
          mixin: state,
        })),
      this.props.appState
    );

    this.state = {
      language: defaultLang,
      mixin: this.activityStateMixin.initialState(),
    };

    getLanguage().then((languageString) => {
      this.setState({ language: langMap[languageString] });
    });
  }

  componentWillUnmount() {
    this.activityStateMixin.componentWillUnmount();
  }

  getAgenciesArray() {
    const activeAgencies: AgencyWithChatOnlyDetails[] = [];

    if (!isLoading(this.props.agencies)) {
      for (const agency of this.props.agencies.agencies.values()) {
        if (agency.status === "ACTIVE") {
          activeAgencies.push(agency);
        }
      }
    }

    return activeAgencies;
  }

  render() {
    return isLoading(this.props.agencies) || isLoading(this.props.appState.scheduledVisits) ? (
      <div className="VisitsScreen__loadingCont">
        <Ons.ProgressCircular indeterminate={true} />
      </div>
    ) : (
      <MedflytCovidScreen
        agencies={this.getAgenciesArray()}
        close={this.props.onBackClick}
        coronaReports={this.props.coronaReports}
        language={this.state.language}
        onSubmit={this.props.onSubmit}
        visitInstances={this.props.appState.scheduledVisits}
        api={this.props.api}
        onAgencyMemberChatClick={this.props.onAgencyMemberChatClick}
      />
    );
  }
}
